export default __webpack_public_path__ + "static/media/story6.1dfd699d.jpg";